export const NA = '-';
export const MAX_LENGTH_OF_ITEMS = 8;
